<template>
  <ContentWrap>
    <el-card v-loading="loading" shadow="never" class="!max-w-700px">
      <template #header>
        <span class="text-base font-bold">活动配置</span>
      </template>
      <el-form ref="formRef" :model="formData" label-width="160px">
        <el-form-item label="用户发布">
          <el-radio-group v-model="formData.userPublish">
            <el-radio :value="true">允许</el-radio>
            <el-radio :value="false">禁止</el-radio>
          </el-radio-group>
          <div class="text-gray-500 text-xs ml-2">选择"禁止"则用户不允许发布活动</div>
        </el-form-item>
        <el-form-item label="是否审核">
          <el-radio-group v-model="formData.auditEnabled">
            <el-radio :value="true">是</el-radio>
            <el-radio :value="false">否</el-radio>
          </el-radio-group>
          <div class="text-gray-500 text-xs ml-2">选择"是"则用户发布的活动需要平台审核</div>
        </el-form-item>
        <el-form-item label="报名积分数">
          <el-input-number v-model="formData.signupPoints" :min="0" :value-on-clear="0" />
          <div class="text-gray-500 text-xs ml-2">用户报名成功后可获得积分</div>
        </el-form-item>
        <el-form-item label="签到积分数">
          <el-input-number v-model="formData.signinPoints" :min="0" :value-on-clear="0" />
          <div class="text-gray-500 text-xs ml-2">用户报名签到成功后可获得积分</div>
        </el-form-item>
        <el-form-item label="邀请报名积分数">
          <el-input-number v-model="formData.inviteSignupPoints" :min="0" :value-on-clear="0" />
          <div class="text-gray-500 text-xs ml-2">邀请用户报名成功后可获得积分</div>
        </el-form-item>
        <el-form-item label="邀请签到积分数">
          <el-input-number v-model="formData.inviteSigninPoints" :min="0" :value-on-clear="0" />
          <div class="text-gray-500 text-xs ml-2">邀请用户报名签到成功后可获得积分</div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="submitLoading" @click="submitForm">
            提 交
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </ContentWrap>
</template>

<script setup lang="ts">
import * as ConfigApi from '@/api/activity/config'

defineOptions({ name: 'ActivityConfig' })

const message = useMessage()
const loading = ref(true)
const submitLoading = ref(false)
const formRef = ref()
const formData = reactive<any>({
  id: undefined,
  userPublish: true,
  auditEnabled: true,
  signupPoints: 0,
  signinPoints: 0,
  inviteSignupPoints: 0,
  inviteSigninPoints: 0
})

const getConfig = async () => {
  loading.value = true
  try {
    const data = await ConfigApi.getActivityConfig()
    Object.assign(formData, data || {})
  } finally {
    loading.value = false
  }
}

const submitForm = async () => {
  submitLoading.value = true
  try {
    await ConfigApi.saveActivityConfig(formData)
    message.success('保存成功')
    getConfig()
  } finally {
    submitLoading.value = false
  }
}

onMounted(() => getConfig())
</script>
